import { render, staticRenderFns } from "./userMy_userinfoAttr.vue?vue&type=template&id=cd7c53b2&scoped=true"
import script from "./userMy_userinfoAttr.vue?vue&type=script&lang=js"
export * from "./userMy_userinfoAttr.vue?vue&type=script&lang=js"
import style0 from "./userMy_userinfoAttr.vue?vue&type=style&index=0&id=cd7c53b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7c53b2",
  null
  
)

component.options.__file = "userMy_userinfoAttr.vue"
export default component.exports